import '../css/LoadingDots.css'; // Separate CSS for loader

const LoadingDots = ({ size = 14, color = '', className = '' }) => {
  return (
    <div className={`dots-fade-loader-container ${className}`}>
      <div className="dots-fade-loader">
        <div style={{ width: size, height: size, backgroundColor: color }} />
        <div style={{ width: size, height: size, backgroundColor: color }} />
        <div style={{ width: size, height: size, backgroundColor: color }} />
      </div>
    </div>
  );
};

export default LoadingDots;
